import {
  ClassOutput,
  RegionOutput,
  SchoolOutput,
  SerieOutput,
} from '@/api/gql/graphql';
import { useGetClasses, useGetSchools, useGetSeries } from '@/api/hooks';
import { useGetRegions } from '@/api/hooks/useRegion';
import { Modal } from '@/components/Layout';
import FilterOptions from '@/components/Ui/FilterOptions/FilterOptions';
import { useUsersList } from '@/components/Views/Users/useUsersList';
import { useFilterStore } from '@/store/useFilterOptionsStore';

const categories = [
  { id: 'school', label: 'École', count: 0, hasSearch: true },
  { id: 'class', label: 'Classe', count: 0 },
  { id: 'gender', label: 'Genre', count: 0 },
  { id: 'region', label: 'Région', count: 0 },
  { id: 'serie', label: 'Série', count: 0 },
];

const FilterUser = () => {
  const { searchTerm, clearFilters, isOpenFilter, setIsOpenFilter } =
    useFilterStore();
  const { applyFilters } = useUsersList()
  const { data: classes } = useGetClasses({});
  const { data: schools } = useGetSchools({
    search: searchTerm,
    limit: 10,
  });
  const { data: regions } = useGetRegions();
  const { data: series } = useGetSeries({});

  const optionsData = {
    school:
      schools?.map((school: SchoolOutput) => ({
        id: school._id,
        value: school._id,
        label: school.name,
      })) || [],
    class:
      classes?.map((classe: ClassOutput) => ({
        id: classe._id,
        value: classe._id,
        label: classe.name,
      })) || [],
    region:
      regions?.map((region: RegionOutput) => ({
        id: region._id,
        value: region._id,
        label: region.name,
      })) || [],
    serie:
      series?.map((serie: SerieOutput) => ({
        id: serie._id,
        value: serie._id,
        label: serie.name,
      })) || [],
    gender: [
      { id: '1', value: 'M', label: 'Masculin' },
      { id: '2', value: 'F', label: 'Féminin' },
    ],
  };

  const handleApplyFilters = () => {
    applyFilters();
    setIsOpenFilter(false);
  };

  const handleCloseModal = () => {
    clearFilters();
    setIsOpenFilter(false);
  };

  const handleClearFilters = () => {
    clearFilters();
  };

  return (
    <Modal
      isOpen={isOpenFilter}
      onClose={handleCloseModal}
      headerStyle="bg-bg rounded-t-[30.9px]"
      modalStyle="bg-bg mb-0 p-0 rounded-b-[30.9px] w-[489px]"
    >
      <FilterOptions
        title="Filtre Utilisateurs"
        categories={categories}
        optionsData={optionsData}
        onApplyFilters={handleApplyFilters}
        onClearFilters={handleClearFilters}
      />
    </Modal>
  );
};

export default FilterUser;
